import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyD4K1ehCggaVDzlOdw8LK13TYj5krkG__E",
  authDomain: "greennest-92490.firebaseapp.com",
  projectId: "greennest-92490",
  storageBucket: "greennest-92490.firebasestorage.app",
  messagingSenderId: "658578803615",
  appId: "1:658578803615:web:cc1c1fc53a0511faf64baa",
  measurementId: "G-THK6876CE1"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app;






// const firebaseConfig = {
//   apiKey: "AIzaSyD4K1ehCggaVDzlOdw8LK13TYj5krkG__E",
//   authDomain: "greennest-92490.firebaseapp.com",
//   projectId: "greennest-92490",
//   storageBucket: "greennest-92490.firebasestorage.app",
//   messagingSenderId: "658578803615",
//   appId: "1:658578803615:web:cc1c1fc53a0511faf64baa",
//   measurementId: "G-THK6876CE1"
// };